module.exports = __webpack_public_path__ + "img/logo-white.8ccaf5fe.png";